import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useDevMode } from './AppTheme';

export default function ColorModeSelect(props) {
  const { mode, setMode } = useColorScheme();
  const { isDevMode, setIsDevMode } = useDevMode();


  // Create a combined value for display
  const displayValue = isDevMode ? 'dev' : mode;
  
  const handleChange = (event) => {
    const value = event.target.value;
    if (value === 'dev') {
      setIsDevMode(true);
      setMode('light'); // Dev mode is based on light mode
    } else {
      setIsDevMode(false);
      setMode(value);
    }
  };

  React.useEffect(()=>{
    if (props.isDev){
      handleChange({target:{value:'dev'}})
    }
  },[])

  if (!mode) {
    return null;
  }





  return (

    <Select
      value={displayValue}
      onChange={handleChange}
      SelectDisplayProps={{
        'data-screenshot': 'toggle-mode',
      }}
      {...props}
    >
      <MenuItem value="system">System</MenuItem>
      <MenuItem value="light">Light</MenuItem>
      <MenuItem value="dark">Dark</MenuItem>
      {props.isDev ?
        <MenuItem value="dev">Dev</MenuItem> : null}
    </Select>
  );
}
